import Vue, { VueConstructor } from 'vue'
import applyMixin from './mixin'
import applyDirective from './directive'

let __Vue: VueConstructor<Vue>
export default function install(_Vue: VueConstructor<Vue>) {
  if (__Vue && _Vue === __Vue) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(
        '[buryPoint] already installed. Vue.use(buryPoint) should be called only once.'
      )
    }
    return
  }
  __Vue = _Vue
  applyMixin(__Vue)
  applyDirective(__Vue)
}
